module.exports = __webpack_public_path__ + "img/logo_white_with_text.0c80144e.svg";